const COUNTER_ANIMATION_LENGTH = 4000;
const COUNTER_SELECTOR = ".stats-wrapper .count-number";
let counterElements;

window.addEventListener("load", () => {
    const observer = new IntersectionObserver(function (entries) {
        if (entries.some(entry => entry.intersectionRatio >= 0.9 && entry.target.dataset.started === undefined)) {
            entries.forEach(el => {
                if (el.intersectionRatio >= 0.9 && el.target.dataset.started === undefined) {
                    el.target.dataset.started = true;
                }
            });
            window.requestAnimationFrame(drawFrame);
        }
    }, { threshold: 0.9 });

    counterElements = document.querySelectorAll(COUNTER_SELECTOR);
    counterElements.forEach(el => observer.observe(el));
}, false);

function drawFrame(timestamp) {
    let runAgain = false;

    for (let element of counterElements) {
        if (element.dataset.started === undefined) continue;

        let start = element.dataset.start;
        let previousCount = element.dataset.previousCount;
        let previousTimestamp = element.dataset.previousTimestamp;

        if (start === undefined) {
            start = timestamp;
            element.dataset.start = timestamp;
            element.dataset.targetCount = element.innerHTML.replace(/\./g, "");

            runAgain = true;
        }

        const targetCount = parseInt(element.dataset.targetCount);
        const elapsed = timestamp - start;

        if (previousTimestamp !== timestamp) {
            const absoluteProgress = Math.min(elapsed / COUNTER_ANIMATION_LENGTH, 1);
            const easedProgress = easeOutQuint(absoluteProgress);
            const currentCount = Math.round(targetCount * easedProgress);

            if (currentCount !== previousCount) {
                const formattedCount = formatNumber(currentCount);
                element.innerHTML = formattedCount;
                element.dataset.previousCount = currentCount;
            }

            if (elapsed <= COUNTER_ANIMATION_LENGTH) {
                runAgain = true;
            }
        }

        if (elapsed < COUNTER_ANIMATION_LENGTH) {
            element.dataset.previousTimestamp = timestamp;
        }
    }

    if (runAgain) {
        window.requestAnimationFrame(drawFrame);
    }
}

function formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

// https://easings.net
function easeOutQuint(x) {
    return x === 1 ? 1 : 1 - Math.pow(1 - x, 5);
}